import React from 'react';

import { BaseExportDialog } from '../../../SimulationExportDialog/components/BaseExportDialog';
import { useExportCheckboxes } from '../../../SimulationExportDialog/hooks/useExportCheckboxes';

interface ExportDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedRequest: any;
  operationDetails: any;
  documentsToApply: any;
  isSimulation?: boolean;
}

const ExportDialog = (props: ExportDialogProps) => {
  const {
    open,
    setOpen,
    selectedRequest,
    operationDetails,
    documentsToApply,
    isSimulation = false,
  } = props;

  const [checkboxes, setters] = useExportCheckboxes({
    includeRateComposition: true,
    includePayouts: false,
  });

  return (
    <BaseExportDialog
      open={open}
      setOpen={setOpen}
      selectedRequest={selectedRequest}
      operationDetails={operationDetails}
      checkboxes={checkboxes}
      setters={setters}
      buildRequestOptions={{
        documentsToApply,
        isSimulation,
      }}
      exportOptions={{
        includePayouts: false,
        canShowPayouts: false,
      }}
      includeRateComposition={true}
    />
  );
};

export default ExportDialog;
